import {ChildEntity} from "typeorm";
import {ShallowRef} from "vue";
import {Component} from "@vue/runtime-core";
import PlayerContractCareerEndNotificationComponent
  from "@/modules/team/components/PlayerContractCareerEndNotification.vue";
import {TransferOfferNotification} from "@/modules/transfer-market/entity/TransferOfferNotification";
import {LocationAsRelativeRaw} from "vue-router";

@ChildEntity()
export class PlayerContractCareerEndNotification extends TransferOfferNotification {
  get to(): LocationAsRelativeRaw | undefined {
    return {name: 'squads.contracts'};
  }

  get component(): ShallowRef<Component> {
    return shallowRef(PlayerContractCareerEndNotificationComponent);
  }
}